import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { Link, navigate } from 'gatsby';
import React from 'react';
import FB from '../firebase';
import If from './If';
import { TypeOcr } from './Types';
import { useUser } from './UserProvider';

function ResourceMenu() {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <Button
        id='Resources'
        aria-controls={open ? 'resources' : undefined}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
        variant='text'
        disableElevation
        onClick={handleClick}
        endIcon={open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        color='info'
        sx={{ borderRadius: 0, justifyContent: 'left' }}
        style={{ fontFamily: 'OCR A Std' }}
      >
        Resources
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        elevation={0}
        sx={{ borderRadius: 0 }}
        PaperProps={{
          style: {
            width: 350,
          },
        }}
        MenuListProps={{
          sx: { backgroundColor: 'success.dark' },
        }}
      >
        <Divider />
        <Stack alignItems='left'>
          <Stack
            direction={{ xs: 'column', sm: 'column', md: 'row', lg: 'row' }}
            justifyContent='center'
            ml={3}
            mr={3}
          >
            <Stack>
              <MenuItem
                onClick={handleClose}
                component={'a'}
                href='/blogs/loquelic-literitas-the-blog/'
              >
                <Typography color='black'>BLOG</Typography>
              </MenuItem>

              <MenuItem
                onClick={handleClose}
                component={'a'}
                href='https://manuals.noiseengineering.us/'
              >
                <Typography color='black'>MANUALS</Typography>
              </MenuItem>
              <MenuItem
                onClick={handleClose}
                component={'a'}
                href='/pages/artists'
              >
                <Typography color='black'>ARTISTS</Typography>
              </MenuItem>

              <MenuItem
                onClick={handleClose}
                component={'a'}
                href='/pages/artist-application'
              >
                <Typography color='black'>
                  BE A NOISE ENGINEERING ARTIST
                </Typography>
              </MenuItem>
            </Stack>
          </Stack>
        </Stack>
      </Menu>
    </>
  );
}
function AboutMenu() {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [close, setClose] = React.useState('ADD+');
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <Button
        id='Platforms'
        aria-controls={open ? 'Platforms' : undefined}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
        variant='text'
        disableElevation
        onClick={handleClick}
        endIcon={open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        color='info'
        sx={{ justifyContent: 'left' }}
        style={{ fontFamily: 'OCR A Std' }}
      >
        About Us
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        elevation={0}
        PaperProps={{
          style: {
            width: 350,
          },
        }}
        MenuListProps={{
          sx: { backgroundColor: 'success.dark' },
        }}
      >
        <Box sx={{ borderRadius: 0 }}>
          <Divider />
          <Stack mr={10}>
            <MenuItem onClick={handleClose} component={'a'} href='/pages/about'>
              <Typography color='black'>WHO WE ARE</Typography>
            </MenuItem>
            <MenuItem
              onClick={handleClose}
              component={'a'}
              href='/pages/environment'
            >
              <Typography color='black'>SUSTAINABILITY STATEMENT</Typography>
            </MenuItem>

            <MenuItem
              onClick={handleClose}
              component={'a'}
              href='/pages/retailers'
            >
              <Typography color='black'>OUR RETAILERS</Typography>
            </MenuItem>
          </Stack>
        </Box>
      </Menu>
    </>
  );
}

function SupportMenu() {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [close, setClose] = React.useState('ADD+');
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <Button
        id='Platforms'
        aria-controls={open ? 'Platforms' : undefined}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
        variant='text'
        disableElevation
        onClick={handleClick}
        endIcon={open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        color='info'
        sx={{ justifyContent: 'left' }}
        style={{ fontFamily: 'OCR A Std' }}
      >
        Support
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        elevation={0}
        PaperProps={{
          style: {
            width: 350,
          },
        }}
        MenuListProps={{
          sx: { backgroundColor: 'success.dark' },
        }}
      >
        <Box sx={{ borderRadius: 0 }}>
          <Divider />
          <Stack mr={10}>
            <MenuItem onClick={handleClose} component={'a'} href='/pages/faq'>
              <Typography color='black'>FAQS</Typography>
            </MenuItem>
            <MenuItem
              onClick={handleClose}
              component={'a'}
              href='/pages/contact-us'
            >
              <Typography color='black'>CONTACT US</Typography>
            </MenuItem>
            <MenuItem
              onClick={handleClose}
              component={'a'}
              href='https://manuals.noiseengineering.us/'
            >
              <Typography color='black'>MANUALS</Typography>
            </MenuItem>
          </Stack>
        </Box>
      </Menu>
    </>
  );
}

function PlatformMenu() {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [close, setClose] = React.useState('ADD+');
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <Button
        id='Platforms'
        aria-controls={open ? 'Platforms' : undefined}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
        variant='text'
        disableElevation
        onClick={handleClick}
        endIcon={open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        color='info'
        sx={{ justifyContent: 'left' }}
        style={{ fontFamily: 'OCR A Std' }}
      >
        Platforms
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        elevation={0}
        PaperProps={{
          style: {
            width: 350,
          },
        }}
        MenuListProps={{
          sx: { backgroundColor: 'success.dark' },
        }}
      >
        <Box sx={{ borderRadius: 0 }}>
          <Divider />
          <Stack mr={10}>
            <MenuItem
              onClick={handleClose}
              component={'a'}
              href='/pages/platforms'
            >
              <Typography color='black'>WHAT'S A PLATFORM MODULE?</Typography>
            </MenuItem>
            <MenuItem
              onClick={handleClose}
              component={'a'}
              href='/pages/world-of-alia'
            >
              <Typography color='black'>WORLD OF ALIA</Typography>
            </MenuItem>
            <MenuItem
              onClick={handleClose}
              component={'a'}
              href='/pages/world-of-legio'
            >
              <Typography color='black'>WORLD OF LEGIO</Typography>
            </MenuItem>
            <MenuItem
              onClick={handleClose}
              component={'a'}
              href='/pages/world-of-versio'
            >
              <Typography color='black'>WORLD OF VERSIO</Typography>
            </MenuItem>
          </Stack>
        </Box>
      </Menu>
    </>
  );
}

function ShopMenu() {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <Button
        id='Shop'
        aria-controls={open ? 'shop' : undefined}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
        variant='text'
        disableElevation
        onClick={handleClick}
        endIcon={open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        color='info'
        sx={{ borderRadius: 0, justifyContent: 'left' }}
        style={{ fontFamily: 'OCR A Std' }}
      >
        Shop
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        elevation={0}
        PaperProps={{
          style: {
            width: 350,
          },
        }}
        MenuListProps={{
          sx: { backgroundColor: 'success.dark' },
        }}
      >
        <Divider />
        <Stack mr={10}>
          <MenuItem
            onClick={handleClose}
            component={'a'}
            href='/collections/modules'
          >
            <Typography color='black'>MODULES</Typography>
          </MenuItem>
          <MenuItem
            onClick={handleClose}
            component={'a'}
            href='/collections/bundles'
          >
            <Typography color='black'>MODULE BUNDLES </Typography>
          </MenuItem>
          <MenuItem
            onClick={handleClose}
            component={'a'}
            href='/collections/pedals'
          >
            <Typography color='black'>PEDALS</Typography>
          </MenuItem>

          <MenuItem
            onClick={handleClose}
            component={'a'}
            href='/collections/software'
          >
            <Typography color='black'>PLUGINS</Typography>
          </MenuItem>

          <MenuItem
            onClick={handleClose}
            component={'a'}
            href='/collections/accessories'
          >
            <Typography color='black'>ACCESSORIES</Typography>
          </MenuItem>

          <MenuItem
            onClick={handleClose}
            component={'a'}
            href='/pages/world-of-alia'
          >
            <Typography color='black'>WORLD OF ALIA</Typography>
          </MenuItem>
          <MenuItem
            onClick={handleClose}
            component={'a'}
            href='/pages/world-of-legio'
          >
            <Typography color='black'>WORLD OF LEGIO</Typography>
          </MenuItem>
          <MenuItem
            onClick={handleClose}
            component={'a'}
            href='/pages/world-of-versio'
          >
            <Typography color='black'>WORLD OF VERSIO</Typography>
          </MenuItem>

          <MenuItem
            onClick={handleClose}
            component={'a'}
            href='/collections/legacy'
          >
            <Typography color='black'>LEGACY PRODUCTS</Typography>
          </MenuItem>
          <MenuItem
            onClick={handleClose}
            component={'a'}
            href='/pages/samplepack'
          >
            <Typography color='black'>SAMPLE PACKS</Typography>
          </MenuItem>
        </Stack>
        <Divider
          style={{ width: '100%' }}
          flexItem
          color='black'
          role='presentation'
        />
        <MenuItem onClick={handleClose} component={'a'} href='/collections/all'>
          <Typography fontSize='14px' color='black' fontWeight='bold'>
            SHOP ALL
          </Typography>
        </MenuItem>
      </Menu>
    </>
  );
}

function Search() {
  return (
    <>
      {' '}
      <Button
        aria-controls={open ? 'search' : undefined}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
        variant='text'
        disableElevation
        onClick={() => {
          navigate('/search');
        }}
        color='info'
        sx={{ borderRadius: 0, justifyContent: 'left', py: '0' }}
        style={{ fontFamily: 'OCR A Std' }}
      >
        <SearchIcon sx={{ my: 1, ml: 0 }} /> SEARCH
      </Button>
    </>
  );
}

export default function Hamburger() {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const user = useUser();
  return (
    <>
      <Button
        aria-controls={open ? 'resources' : undefined}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
        variant='text'
        disableElevation
        onClick={handleClick}
      >
        <MenuIcon color='info' />
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        elevation={0}
        PaperProps={{ sx: { width: '350px' } }}
        sx={{ borderRadius: 0 }}
        MenuListProps={{
          sx: { backgroundColor: 'success.dark' },
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <Stack>
          <Button
            style={{ fontFamily: 'OCR A Std' }}
            name='home'
            color='info'
            onClick={() => {
              navigate('/');
            }}
          >
            HOME
          </Button>

          <Divider />
          <ShopMenu />
          <Divider />
          <PlatformMenu />
          <Divider />
          <ResourceMenu />
          <Divider />
          <AboutMenu />
          <Divider />
          <SupportMenu />
          <Divider />
          <Button
            id='firmware swap'
            variant='text'
            disableElevation
            onClick={handleClick}
            color='info'
            sx={{ justifyContent: 'left' }}
            style={{ fontFamily: 'OCR A Std' }}
            component={'a'}
            href='/portal/firmware'
          >
            <TypeOcr fontSize='14px' textAlign='left' color='info.main'>
              SWAP FIRMWARES
            </TypeOcr>
          </Button>

          <Divider />
          <Button
            id='UI Update'
            variant='text'
            disableElevation
            onClick={handleClick}
            color='info'
            sx={{ justifyContent: 'left' }}
            style={{ fontFamily: 'OCR A Std' }}
            component={'a'}
            href='/portal/univer-inter'
          >
            <TypeOcr fontSize='14px' textAlign='left' color='info.main'>
              UPDATE UNIVER INTER CONFIG
            </TypeOcr>
          </Button>
          <Divider />
          <Search />
          <Divider />
          <If value={!user.valid}>
            <Button
              onClick={() => {
                navigate('/portal/login');
              }}
              variant='text'
            >
              <TypeOcr textAlign='left' fontSize='0.88rem' color='black'>
                LOG IN
              </TypeOcr>
            </Button>{' '}
          </If>
          <If value={user.valid}>
            <Button
              onClick={() => {
                FB.auth.signOut();
              }}
            >
              <TypeOcr textAlign='left' fontSize='0.88rem' color='black'>
                LOG OUT
              </TypeOcr>
            </Button>
          </If>
        </Stack>
      </Menu>
    </>
  );
}
